module.exports = __webpack_public_path__ + "img/LighterThan5kg-gray.8cc12b4c.svg";